import { Component, Input } from '@angular/core';

@Component({
    selector: 'icon-health-insurance',
    templateUrl: './health-insurance.component.html',
    styleUrls: ['./health-insurance.component.css'],
    standalone: false
})
export class HealthInsuranceComponent {
  @Input() size = 24;
  @Input() color = '#000';
}
